import { useEffect, type ReactNode } from 'react';
import { TXProvider } from '@transifex/react';

import { getTransifexToken } from '../config/runtimeConfig';
import { getSystemLocale, getTransifexLocale } from '../utils/getSystemLocale';
import { configureLoginTxToken, loginTx } from './loginTx';

type LoginStringsProps = {
  // Outside <LoginRoot> there's no login config, so the host passes login's Transifex token.
  token?: string;
  children: ReactNode;
};

// With no token and no login config, the copy stays in English instead of throwing.
const resolveToken = (token?: string): string | undefined => {
  if (token) return token;
  try {
    return getTransifexToken();
  } catch {
    return undefined;
  }
};

/** Scopes useT() to login's Transifex project, in the device's language. */
export const LoginStrings = ({ token, children }: LoginStringsProps) => {
  const resolved = resolveToken(token);
  if (resolved) configureLoginTxToken(resolved);

  useEffect(() => {
    const locale = getTransifexLocale(getSystemLocale());
    if (locale !== 'en' && loginTx.getCurrentLocale() !== locale) {
      loginTx.setCurrentLocale(locale).catch(() => {
        /* offline / CDS error — falls through to source strings */
      });
    }
  }, []);

  return <TXProvider instance={loginTx}>{children}</TXProvider>;
};
